// import React from "react";
// import Dashboard from "./components/Dashboard";
// import GbuHostelLogin from "./components/GbuHostelLogin";
// import Profile from "./components/Profile";
// import StudentRegister from "./components/StudentRegister";
// import RoomBooking from "./components/RoomBooking";
// import ForgotPassword from "./components/ForgotPassword";
// import HostelForms from "./components/HostelForms"; 
// import { getToken, removeToken } from "./services/auth";
// import { Routes, Route, Navigate } from "react-router-dom";

// export default function App() {
//   const isAuthenticated = getToken() !== null;

//   const handleLogin = () => {
//     // After login, reload to force fresh evaluation
//     window.location.href = "/";
//   };

//   const handleLogout = () => {
//     removeToken();
//     window.location.href = "/";
//   };

//   return (
//     <Routes>
//       <Route
//         path="/"
//         element={
//           isAuthenticated ? (
//             <Dashboard onLogout={handleLogout} />
//           ) : (
//             <GbuHostelLogin onLogin={handleLogin} />
//           )
//         }
//       />
//       <Route
//         path="/profile"
//         element={
//           isAuthenticated ? (
//             <Profile onLogout={handleLogout} />
//           ) : (
//             <Navigate to="/" />
//           )
//         }
//       />
//       <Route
//         path="/roombooking"
//         element={
//           isAuthenticated ? (
//             <RoomBooking onLogout={handleLogout} />
//           ) : (
//             <Navigate to="/" />
//           )
//         }
//       />
//       <Route
//         path="/hostel-forms"
//         element={
//           isAuthenticated ? (
//             <HostelForms onLogout={handleLogout} />
//           ) : (
//             <Navigate to="/" />
//           )
//         }
//       />
//       <Route path="/register" element={<StudentRegister />} />
//       <Route path="/forgot-password" element={<ForgotPassword />} />
//       <Route path="*" element={<Navigate to="/" />} />
//     </Routes>
//   );
// }


import React, { useState } from "react";
import Dashboard from "./components/Dashboard";
import GbuHostelLogin from "./components/GbuHostelLogin";
import Profile from "./components/Profile";
import StudentRegister from "./components/StudentRegister";
import RoomBooking from "./components/RoomBooking";
import HostelHistory from "./components/HostelHistory";
import ForgotPassword from "./components/ForgotPassword";
import HostelForms from "./components/HostelForms"; 
import LeaveApplication from "./components/LeaveApplication";
import { getToken, removeToken } from "./services/auth";
import { Routes, Route, Navigate } from "react-router-dom";
import EditStudentDetails from "./components/EditStudentDetails";

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(getToken() !== null);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    removeToken();
    setIsAuthenticated(false);
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Dashboard onLogout={handleLogout} />
          ) : (
            <GbuHostelLogin onLogin={handleLogin} />
          )
        }
      />
      <Route
        path="/profile"
        element={
          isAuthenticated ? (
            <Profile onLogout={handleLogout} />
          ) : (
            <Navigate to="/" />
          )
        }
      />
      <Route
        path="/roombooking"
        element={
          isAuthenticated ? (
            <RoomBooking onLogout={handleLogout} />
          ) : (
            <Navigate to="/" />
          )
        }
      />
      <Route
        path="/hostel-forms"
        element={
          isAuthenticated ? (
            <HostelForms onLogout={handleLogout} />
          ) : (
            <Navigate to="/" />
          )
        }
      />
      <Route
        path="/leave-application"
        element={
          isAuthenticated ? (
            <LeaveApplication onLogout={handleLogout} />
          ) : (
            <Navigate to="/" />
          )
        }
      />
       <Route
        path="/edit-details"
        element={
          isAuthenticated ? (
            <EditStudentDetails onLogout={handleLogout} />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/hostelhistory"
        element={
          isAuthenticated ? (
            <HostelHistory onLogout={handleLogout} />
          ) : (
            <Navigate to="/" />
          )
        }
      />
      
      <Route path="/register" element={<StudentRegister />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
